var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"create-project pa-5"},[_c('h2',{staticClass:"font-weight-medium mb-5"},[_vm._v(" Create New Project ")]),(_vm.showEditForm)?_c('create-project-form'):(!_vm.loading)?_c('create-project-details'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }